// extracted by mini-css-extract-plugin
module.exports = {"messagePillContainer":"_2QLWOxNcaSzgDAUhSlYUYv"};